// react
import React from 'react';
import ProToolView from './app';
import { config } from '@shakkerai/config';
import { createRoot } from 'react-dom/client';

const env = config.env === 'aws' ? 'shakker' : 'pic';

const container = document.getElementById('root');

container.classList.remove('dark');
container.classList.add('light');
container.classList.add('select-none');
container.classList.add('select-test');

document.querySelector('html').classList.add('env-' + env);

const root = createRoot(container);
root.render(<ProToolView />);
